import React from "react";
import { Check, AlertCircle } from "lucide-react";

export function Stepper({ steps, current, statuses, onSelect }) {
  return (
    <ol className="flex flex-wrap gap-2 mb-5" data-testid="visit-stepper">
      {steps.map((s, i) => {
        const issues = statuses[s.key] || [];
        const active = i === current;
        const done = issues.length === 0;
        const tone = active ? "bg-slate-950 text-white border-slate-950" : done ? "bg-emerald-50 text-emerald-800 border-emerald-200" : "bg-white text-slate-600 border-slate-200 hover:border-slate-400";
        return (
          <li key={s.key}>
            <button type="button" onClick={() => onSelect(i)} className={`inline-flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-full border transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 ${tone}`} data-testid={`visit-step-${s.key}`} aria-current={active ? "step" : undefined}>
              <span className={`h-4 w-4 rounded-full inline-flex items-center justify-center text-[10px] ${active ? "bg-white text-slate-950" : done ? "bg-emerald-600 text-white" : "bg-slate-200 text-slate-700"}`}>
                {done && !active ? <Check className="h-3 w-3" /> : i + 1}
              </span>
              {s.label}
            </button>
          </li>
        );
      })}
    </ol>
  );
}

export function RequirementsChecklist({ issues }) {
  if (issues.length === 0) {
    return (
      <div className="rounded-md border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm text-emerald-900 flex items-center gap-2" data-testid="visit-requirements-ok">
        <Check className="h-4 w-4" /> All inspection requirements met — ready to submit.
      </div>
    );
  }
  return (
    <div className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900" data-testid="visit-requirements-missing">
      <div className="font-semibold mb-1">{issues.length} requirement{issues.length > 1 ? "s" : ""} pending</div>
      <ul className="space-y-0.5">
        {issues.map((m) => <li key={m} className="flex items-start gap-1.5 text-xs"><AlertCircle className="h-3.5 w-3.5 mt-0.5 flex-shrink-0" />{m}</li>)}
      </ul>
    </div>
  );
}

export function Field({ label, children, className = "" }) {
  return (
    <div className={className}>
      <label className="text-xs font-medium text-slate-700 leading-none block mb-1.5">{label}</label>
      {children}
    </div>
  );
}

export function NativeSelect({ value, onChange, options, placeholder, testId }) {
  return (
    <select value={value} onChange={(e) => onChange(e.target.value)} className="flex h-9 w-full rounded-md border border-slate-300 bg-white px-3 text-sm" data-testid={testId}>
      <option value="">{placeholder || "Select…"}</option>
      {options.map((o) => (typeof o === "string" ? <option key={o} value={o}>{o}</option> : <option key={o.value} value={o.value}>{o.label}</option>))}
    </select>
  );
}
